/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Changing_Carrier_ExplanationInputs */

const en_orders_changing_carrier_explanation = /** @type {(inputs: Orders_Changing_Carrier_ExplanationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changing carrier can invalidate quote or rate assumptions for this order.`)
};

const es_orders_changing_carrier_explanation = /** @type {(inputs: Orders_Changing_Carrier_ExplanationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar el transportista puede invalidar supuestos de cotizacion o tarifa para este pedido.`)
};

/**
* | output |
* | --- |
* | "Changing carrier can invalidate quote or rate assumptions for this order." |
*
* @param {Orders_Changing_Carrier_ExplanationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_changing_carrier_explanation = /** @type {((inputs?: Orders_Changing_Carrier_ExplanationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Changing_Carrier_ExplanationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_changing_carrier_explanation(inputs)
	return es_orders_changing_carrier_explanation(inputs)
});